import { generateUniqueCardId } from 'backend/helpers/cardHelpers'
import {
  EdithBlockLayout,
  EdithBlockType,
} from 'backend/services/types/edithService.enums'
import * as Edith from 'backend/services/types/edithService.types'
import { ProductType } from 'backend/services/types/urApiService.enums'
import { RouteProductType } from 'frontend/enums'
import { Block, EdithBlockProduct, StartPage } from 'frontend/types'
import productUtils from 'utils/productUtils'

const FMG_LIMIT = 5

export const DEFAULT_RECOMMENDATIONS_ENDPOINT = 'cf_implicit_ab_test_v2'

const getLink = (product: Edith.EdithBlockProduct) => {
  const isLinkProduct = 'url' in product

  if (isLinkProduct) {
    return product.url
  } else if (product.type === Edith.EdithProductType.NAVIGATION_PRODUCT) {
    return `/bladdra/${product.slug}`
  } else {
    return `/${
      product.productType === ProductType.SERIES
        ? RouteProductType.SERIES
        : product.productType === ProductType.TRAILER
          ? RouteProductType.TRAILER
          : RouteProductType.PROGRAM
    }/${productUtils.getSlug(product)}`
  }
}

const adaptBlocks = (block: Edith.Block): Block => {
  const isFmgBlock = block.layout === EdithBlockLayout.FMG
  const numberOfProducts = block.products ? block.products.length : 0
  const maxLength = isFmgBlock ? FMG_LIMIT : numberOfProducts

  const products: EdithBlockProduct[] =
    block.products
      .map(product => ({
        ...product,
        link: getLink(product),
        describedById: generateUniqueCardId(),
      }))
      .slice(0, maxLength) || []

  const mainProduct: EdithBlockProduct | null = block.mainProduct
    ? {
        ...block.mainProduct,
        link: getLink(block.mainProduct),
        describedById: generateUniqueCardId(),
      }
    : null

  return {
    ...block,
    title: block.title,
    description: block.description,
    products,
    mainProduct,
    cardLayout: block.cardLayout ?? Edith.EdithCardLayout.DEFAULT,
    ...(block.blockType === EdithBlockType.RECOMMENDATIONS && {
      peach_parameters: block.peach_parameters?.endpoint
        ? block.peach_parameters
        : { endpoint: DEFAULT_RECOMMENDATIONS_ENDPOINT },
    }),
  }
}

const adapt = (startPage: Edith.StartPage): StartPage => {
  return {
    ...startPage,
    blocks: startPage?.blocks.map(adaptBlocks) ?? [],
  }
}

const startPageAdapter = { adapt }

export default startPageAdapter
